const uuidv4 = require('uuid').v4;
module.exports = class Speaker {
    constructor(options) {
        this.id = uuidv4();
        this.name = options.name || "unknown";
        this.colour = options.colour || '#269C88';
    }
}